module.exports = __webpack_public_path__ + "images/zine.png?v=09e11863b97c97c57e21a7d8203de1c9";